import axios from "axios"
import axiosInstance from "./axiosInstance";
import CryptoJS from 'crypto-js';


const SECRET_KEY = process.env.REACT_APP_STRIPE_ENCRYPTION_SECRET_KEY


export async function fetchIsTeacher() {
    if (localStorage.getItem("access") === null || localStorage.getItem("refresh") === "null") {
        return null;
    }
    try {
        const response = await axiosInstance.get("/user/me/");
        if (response.status === 200) {
            const decryptedData = decryptData(response.data.data);
            return decryptedData.isTeacher;
        }
    } catch (error) {
        if (error.response?.status === 404 || error.response?.status === 401 ||
            (error.message && error.message.includes("No refresh token available"))) {
            console.error("XP fetch failed: user not authenticated or endpoint not found");
            return null;
        }
        console.error("problem user_progress.js fetchIsTeacher: " + error.message);
    }
    return null;
}


export async function getMyStudents() {
    try {
        const response = await axiosInstance.get("/user/getMyStudents/");
        if (response.status === 200) {
            const decryptedData = decryptData(response.data.students);
            return decryptedData;
        }
    } catch (error) {
        console.error("problem getMyStudents: " + error.message);
    }
    return [];
}


export async function getStudentSubSaves(username) {
    try {
        const response = await axiosInstance.get("/user/getStudentSubSaves/", {
            params: { username }
        });
        if (response.status === 200) {
            const decryptedData = decryptData(response.data.subStructureSave);
            return decryptedData;
        }
    } catch (error) {
        console.error("problem getStudentSubSaves: " + error.message);
    }
    return [];
}

export async function fetchXp() {
    if (localStorage.getItem("access") === null || localStorage.getItem("refresh") === "null") {
        return null;
    }
    try {
        const response = await axiosInstance.get("/user/me/");
        if (response.status === 200) {
            const decryptedData = decryptData(response.data.data);
            return decryptedData.xp;
        }
    } catch (error) {
        if (error.response?.status === 404 || error.response?.status === 401 ||
            (error.message && error.message.includes("No refresh token available"))) {
            console.error("XP fetch failed: user not authenticated or endpoint not found");
            return null;
        }
        console.error("problem user_progress.js fetchXp: " + error.message);
    }
    return null;
}

export async function fetchLevel() {
    if (localStorage.getItem("access") === null || localStorage.getItem("refresh") === "null") {
        return null;
    }

    try {
        const response = await axiosInstance.get("/user/me/");

        if (response.status === 200) {
            const decryptedData = decryptData(response.data.data);
            return decryptedData.level;
        }
    } catch (error) {
        if (error.response?.status === 404 || error.response?.status === 401 ||
            (error.message && error.message.includes("No refresh token available"))) {
            console.error("Level fetch failed: user not authenticated or endpoint not found");
            return null;
        }
        console.error("problem user_progress.js fetchLevel: " + error.message);
    }
    return null;
}

function decryptData(encryptedData) {
    try {
        // Δημιουργία 32-byte key από το SECRET_KEY (ίδιο με backend)
        const key = CryptoJS.SHA256(SECRET_KEY);

        const decrypted = CryptoJS.AES.decrypt(
            encryptedData,
            key,
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedString);
    } catch (error) {
        console.error("Decryption failed:", error);
        return null;
    }
}


export async function increaseXp(xp) {
    try {
        const response = await axiosInstance.post("/user/increase_xp/", { xp });
        if (response.status === 200) {
            return response.data.xp;
        }
    } catch (error) {
        alert("problem user_progress.js increaseXp: " + error.message);
    }
    return null;
}

export async function sendFeedback(feedback) {
    try {
        const response = await axiosInstance.post("/api/feedback/", { feedback });
        const ok = response.status === 200 || response.status === 201;
        return { success: ok, data: response.data };
    } catch (error) {
        alert("problem sendFeedback : " + error.message);
        return { success: false, error };
    }
}


export async function increaseLevel(level) {
    try {
        const response = await axiosInstance.post("/user/increase_level/", { level });
        if (response.status === 200) {
            return response.data.level;
        }
    } catch (error) {
        alert("problem user_progress.js increaseLevel: " + error.message);
    }
    return null;
}

export async function decreaseXp() {
    try {
        const response = await axiosInstance.post("user/decrease_xp/");
        if (response.status === 200) {
            return response.data.xp;
        }
    } catch (error) {
        alert("problem user_progress.js decreaseXp: " + error.message);
    }
}

export async function changeInfo(field, value) {
    try {
        const response = await axiosInstance.post(`/user/change_${field}/`, { [field]: value });
        if (response.status === 200) {
            return response.data[field];
        }
    } catch (error) {
        return false;
    }
    return null;
}

export async function checkOldPassword(oldPassword) {
    try {
        const response = await axiosInstance.post("/user/checkOldPassword/", { old_password: oldPassword });
        if (response.status === 200) {
            return response.data.valid;
        }
    } catch (error) {
        alert("problem user_progress.js checkOldPassword: " + error.message);
    }
    return false;
}

export async function isQuizDone(stageid) {
    try {
        const response = await axiosInstance.post("/user/isQuizDone/", { stageId: stageid });  //PREPEI NA GINEI GET!!!!
        if (response.status === 200) {
            return response.data.valid;
        }

    }
    catch (error) {
        alert("problem user_progress.js isQUiz done: " + error.message);
    }
    return false;

}

export async function isGameDone(stageid) {
    try {
        const response = await axiosInstance.post("/user/isGameDone/", { stageId: stageid });  //PREPEI NA GINEI GET!!!!
        if (response.status === 200) {
            return response.data.valid;
        }

    }
    catch (error) {
        alert("problem user_progress.js Game done: " + error.message);
    }
    return false;

}


export async function setQuizDone(stageid) {
    try {
        const response = await axiosInstance.post("/user/setQuizDone/", { stageId: stageid });
        if (response.status === 200) {
            return response.status;
        }
    }
    catch (error) {
        alert("problem user_progress.js setQ: " + error.message);
    }
    return false;

}

export async function setGameDone(stageid) {
    try {
        const response = await axiosInstance.post("/user/setGameDone/", { stageId: stageid });
        if (response.status === 200) {
            return response.status;
        }
    }
    catch (error) {
        alert("problem user_progress.js setGame: " + error.message);
    }
    return false;

}

export async function getGameXp(stageid) {
    try {
        const response = await axiosInstance.get("/user/getGameXp/", {
            params: {
                stageId: stageid
            }
        });
        //alert("getQuizXp response:", response);
        return response.data.GameXp;
    } catch (error) {
        alert("problem user_progress.js getGameXp: " + error.message);
    }
}

export async function getQuizXp(stageid) {
    try {
        const response = await axiosInstance.get("/user/getQuizXp/", {
            params: {
                stageId: stageid
            }
        });
        //alert("getQuizXp response:", response);
        return response.data.QuizXp;
    } catch (error) {
        alert("problem user_progress.js getQuizXp: " + error.message);
    }
}

export async function increaseSubStructure(precentage, stageid) {
    try {
        const response = await axiosInstance.post("/user/increaseSubStructure/", {
            prec: precentage,
            stageId: stageid
        });

        if (response.status === 200) {
            const decryptedData = decryptData(response.data.data);
            return response.status;
        }
    } catch (error) {
        console.error("problem user_progress.js increase sub:", error.message);
        alert("problem user_progress.js increase sub: " + error.message);
    }
}


export async function increaseStructure(precentage, stageid, substructure) {
    try {
        const response = await axiosInstance.post("/user/increaseStructure/", {
            prec: precentage,
            stageId: stageid,
            substructure: substructure
        });

        if (response.status === 200) {
            const decryptedData = decryptData(response.data.data);
            return response.status;
        }
    } catch (error) {
        console.error("problem user_progress.js increase structure:", error.message);
        alert("problem user_progress.js increase structure: " + error.message);
    }
}


export async function getSubSave(name) {

    try {
        const response = await axiosInstance.get("/user/getSubSave/", {
            params: {
                subName: name
            }
        })
        if (response.status === 200) {
            return response.data.subStructureSave
        }
    }
    catch (error) {
        alert("problem user_progress.js getSubSave: " + error.message);
    }

}


export async function getDarkMode() {
    // Check if user is authenticated before making API call
    const accessToken = localStorage.getItem("access");
    const refreshToken = localStorage.getItem("refresh");

    // If user is not logged in, return null to use localStorage value instead
    if (!accessToken && !refreshToken) {
        return null;
    }

    try {
        const response = await axiosInstance.get("/user/getDarkMode/")
        if (response.status === 200) {
            return response.data.darkMode
        }
    }
    catch (error) {
        // Don't show alert if error is due to missing authentication (user not logged in)
        if (error.message && error.message.includes("No refresh token available")) {
            console.error("Dark mode fetch failed: user not authenticated");
            return null;
        }
        // Only show alert for other types of errors
        console.error("problem darkMode getter " + error.message);
        // Removed alert to prevent interruption during sign in
    }
    return null;
}

export async function changeDarkMode() {

    try {
        const response = await axiosInstance.post("/user/changeDarkMode/")
        if (response.status === 200)
            return true
    }
    catch (error) {
        alert("problem darkmode changer " + error.message);
    }

}

export async function getIsPremium() {

    const accessToken = localStorage.getItem("access");
    const refreshToken = localStorage.getItem("refresh");

    if (!accessToken && !refreshToken) {
        return false;
    }

    try {
        const response = await axiosInstance.get("/user/getIsPremium/")
        if (response.status === 200) {
            const decryptedData = decryptData(response.data.data);
            return decryptedData.ispremium;
        }
    }
    catch (error) {
        if (error.message && error.message.includes("No refresh token available")) {
            console.error("Premium status fetch failed: user not authenticated");
            return false;
        }
        console.error("problem getIsPremium getter " + error.message);
    }
    return false;
}


// apiHandles/subscriptions.js

export async function cancelSubscription() {
    try {
        const response = await axiosInstance.post("/user/cancel_subscription/");

        if (response.status === 200) {
            return true;
        }

        return false;
    } catch (error) {
        console.error("❌ Error canceling subscription:", error);

        // Πέρασε το error πίσω για καλύτερο handling
        if (error.response) {
            // Server responded with error
            console.error("Server error:", error.response.data);
            throw new Error(error.response.data.error || "Σφάλμα από τον server");
        } else if (error.request) {
            // Request made but no response
            console.error("No response received");
            throw new Error("Δεν ελήφθη απάντηση από τον server");
        } else {
            // Something else happened
            console.error("Error:", error.message);
            throw new Error(error.message);
        }
    }
}

export async function getSubScriptionStatus() {
    try {
        const res = await axiosInstance.get("/user/subscriptionStatus/");
        // 👆 προσαρμόζεις το URL αν είναι διαφορετικό στο backend σου
        return res.data;
    } catch (err) {
        console.error("Error fetching subscription status:", err);
        throw err;
    }
}


export async function getGreekOn() {
    // Check if user is authenticated before making API call
    const accessToken = localStorage.getItem("access");
    const refreshToken = localStorage.getItem("refresh");

    // If user is not logged in, return null to use localStorage value instead
    if (!accessToken && !refreshToken) {
        return null;
    }

    try {
        const response = await axiosInstance.get("/user/getGreekOn/")
        if (response.status === 200) {
            return response.data.greekOn
        }
    }
    catch (error) {
        // Don't show alert if error is due to missing authentication (user not logged in)
        if (error.message && error.message.includes("No refresh token available")) {
            console.error("Greek language fetch failed: user not authenticated");
            return null;
        }
        // Only show alert for other types of errors (network issues, etc.)
        console.error("problem getGreekOn getter " + error.message);
        // Removed alert to prevent interruption during sign in
    }
    return null;
}

export async function changeGreekOn() {

    try {
        const response = await axiosInstance.post("/user/changeGreekOn/")
        if (response.status === 200)
            return true
    }
    catch (error) {
        alert("problem soundOn changer " + error.message);
    }

}

export async function changeIsPremium(params) {
    try {
        const response = await axiosInstance.post("/user/changeIsPremium/")
        if (response.status === 200)
            return true
    }
    catch (error) {
        alert("problem soundOn changer " + error.message);
    }
}


export async function getSoundOn() {
    // Check if user is authenticated before making API call
    const accessToken = localStorage.getItem("access");
    const refreshToken = localStorage.getItem("refresh");

    // If user is not logged in, return null to use localStorage value instead
    if (!accessToken && !refreshToken) {
        return null;
    }

    try {
        const response = await axiosInstance.get("/user/getSoundOn/")
        if (response.status === 200) {
            return response.data.soundOn
        }
    }
    catch (error) {
        // Don't show alert if error is due to missing authentication (user not logged in)
        if (error.message && error.message.includes("No refresh token available")) {
            console.error("Sound setting fetch failed: user not authenticated");
            return null;
        }
        // Only log other types of errors (network issues, etc.) without showing alert
        console.error("problem soundOn getter " + error.message);
        // Removed alert to prevent interruption during sign in
    }
    return null;
}

export async function changeSoundOn() {

    try {
        const response = await axiosInstance.post("/user/changeSoundOn/")
        if (response.status === 200)
            return true
    }
    catch (error) {
        alert("problem soundOn changer " + error.message);
    }

}

export async function deletAccount() {
    try {
        const response = await axiosInstance.post("/user/deleteAccount/");
        if (response.status === 200) {
            return true;
        }
        return false;
    } catch (error) {
        alert("Problem deleting account: " + error.message);
        return false;
    }
}


export function formatExampleText(text) {
    if (!text) return "";

    const lines = text.split("\n");
    const formatted = lines.map((line) => {
        const trimmed = line.trim();

        if (trimmed === "/n") {
            return `<div style="height: 2em;"></div>`;
        }

        if (trimmed.includes("====")) {
            return `<div style="margin-left: 4em">${trimmed.replace(/====/g, "")}</div>`;
        }

        if (trimmed.startsWith(">> >>")) {
            return `<div style="margin-left: 4em">${trimmed.replace(/^>> >>\s?/, "")}</div>`;
        }

        if (trimmed.startsWith("###")) {
            return `<div style="font-weight: 800;color: #da0000ff">${trimmed.replace(/^###\s?/, "")}</div>`;
        }

        if (trimmed.startsWith(">>")) {
            return `<div style="margin-left: 2em">${trimmed.replace(/^>>\s?/, "")}</div>`;
        }

        return trimmed;
    });

    return formatted.join(""); // Added this line
}
